import React from 'react';

import Icon from '@/components/ui/AppIcon';

const newsItems = [
  {
    id: 'news-001',
    title: 'From Humble Beginnings to a Midlands Tradition: The Story of the Braaider Cup',
    excerpt: "Every tradition has a beginning, and for the Braaider Cup, it all started with a few friends, a shared passion for golf, and the unmistakable South African love for a good braai. Back in March 2005, The Witness captured the very first Braaider Cup hosted at Maritzburg Golf Club…",
    href: 'https://maritzburggolfclub.co.za/from-humble-beginnings-to-a-midlands-tradition-the-story-of-the-braaider-cup/',
    category: 'Club History',
    icon: 'TrophyIcon',
  },
  {
    id: 'news-002',
    title: "Tee'd Up for Greatness: Meet Golf's Rising Star, Christelle van Tonder",
    excerpt: "At just 13 years old, Christelle van Tonder is redefining what it means to be a young golf champion. As the youngest female member at Maritzburg Golf Club, Christelle's journey is nothing short of inspiring — a story built on talent, discipline, and an unshakable bond with her biggest supporter…",
    href: 'https://maritzburggolfclub.co.za/teed-up-for-greatness-meet-golfs-rising-star-christelle-van-tonder/',
    category: 'Member Spotlight',
    icon: 'StarIcon',
  },
];

export default function NewsSection() {
  return (
    <section className="py-20 bg-background">
      <div className="max-w-screen-2xl mx-auto px-4 lg:px-8 xl:px-10">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-10">
          <div>
            <span className="text-accent font-semibold text-sm tracking-widest uppercase">News &amp; Blog</span>
            <h2 className="text-3xl font-bold text-foreground mt-2">Latest from MGC</h2>
            <p className="text-muted-foreground mt-2 text-base max-w-md">
              See what&apos;s new at Maritzburg Golf Club — results, upcoming competitions, social updates, and more.
            </p>
          </div>
          <a
            href="https://maritzburggolfclub.co.za/news"
            target="_blank"
            rel="noopener noreferrer"
            className="text-primary font-semibold text-sm hover:text-secondary flex items-center gap-1 transition-colors shrink-0"
          >
            View all news
            <Icon name="ArrowRightIcon" size={16} variant="outline" />
          </a>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {newsItems.map((item) => (
            <a
              key={item.id}
              href={item.href}
              target="_blank"
              rel="noopener noreferrer"
              className="card-hover bg-card border border-border rounded-2xl p-6 flex flex-col group"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-xl gradient-primary flex items-center justify-center shrink-0">
                  <Icon name={item.icon as Parameters<typeof Icon>[0]['name']} size={20} variant="outline" className="text-white" />
                </div>
                <span className="text-xs font-semibold text-accent uppercase tracking-wider bg-accent/10 px-2.5 py-1 rounded-full">
                  {item.category}
                </span>
              </div>
              <h3 className="font-bold text-foreground text-lg leading-snug mb-3 group-hover:text-primary transition-colors">
                {item.title}
              </h3>
              <p className="text-muted-foreground text-sm leading-relaxed flex-1 mb-4">{item.excerpt}</p>
              <div className="flex items-center gap-1.5 text-primary font-semibold text-sm">
                Read more
                <Icon name="ArrowRightIcon" size={14} variant="outline" className="group-hover:translate-x-1 transition-transform" />
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
